import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (withOutZIndex) => ({
  zIndex: withOutZIndex ? 0 : 'unset',
});

export const paper: SxStyle = {
  position: 'relative',
  height: '100vh',
  backgroundColor: (p) => p.palette.common.white,
  backgroundImage: 'none!important',
};

export const settings: SxStyle = { marginTop: 'auto' };

export const icon: SxStyle = { cursor: 'pointer' };

export const divider: SxStyle = {
  // marginY: 1,
  // width: '60%',
  alignSelf: 'center',
  // borderColor: (p) => p.palette.primary[100],
};
